// extracted by mini-css-extract-plugin
export default {"Pagination":"Pagination_mAYuu","Button":"Button_tcsDS","top":"top_GTmSu"};